
.cropArea {
    composes: defaults from "printout.module.css";
    display: inline-block;
    page-break-inside: avoid;
    /* add print preview markers */
    outline: 1px solid lightgray;
}

@media print {
    .cropArea {
        /* remove print preview markers */
        outline: none;
    }
}

.root {
    /* print margins */
    margin: 3mm;
    /* layout */
    --qr-code-size: 15mm;
}

.number {
    font-size: 8px;
    text-align: center;
    white-space: nowrap;
}

.qrCode {
    width: var(--qr-code-size);
    height: var(--qr-code-size);
    border: 2px solid white;
}
